module.exports = __webpack_public_path__ + "static/1.cb471e16.png";


//////////////////
// WEBPACK FOOTER
// D:/Workarea/iota.org/documentation/src/assets/1.png
// module id = 214
// module chunks = 1